/* eslint-disable */
import { Metrics, Colors, Fonts } from '../../Themes'
import { StyleSheet } from 'react-native'

export default StyleSheet.create({
    container: {
        alignItems: 'center',
        borderRadius: 30 / 2,
        height: 30,
        justifyContent: 'center',
        width: 30,
      },
      camera: {
        backgroundColor: Fonts.style.color.primary,
      },
  
      close: {
        backgroundColor: Fonts.style.color.danger,
      },
  
      default: {
        backgroundColor: Fonts.style.color.primary,
      },
  
  })
